import type { EventEmitter, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Directive, inject, input } from '@angular/core';

import type { Observable, Subscription } from 'rxjs';

import { Analytics } from '@core/analytics-types';

/**
 * Directive for trapping focus within a region.
 * @deprecated
 */
@Directive({
  selector: '[rtcAnalyticsTrack]',
  host: {
    '(click)': 'onClick()',
  },
  standalone: true,
})
export class TrackDirective implements OnChanges, OnDestroy {
  private readonly analytics = inject(Analytics);

  public readonly rtcAnalyticsTrack = input<string | false>();
  public readonly rtcAnalyticsTrackData = input<any>({});
  public readonly rtcAnalyticsTrigger = input<Observable<any> | EventEmitter<any>>(undefined!);

  private triggerSubscription?: Subscription;

  public ngOnChanges(changes: SimpleChanges): void {
    const rtcAnalyticsTrigger = this.rtcAnalyticsTrigger();
    if (changes.rtcAnalyticsTrigger && rtcAnalyticsTrigger) {
      if (this.triggerSubscription) this.triggerSubscription.unsubscribe();

      this.triggerSubscription = rtcAnalyticsTrigger.subscribe(() => this.track());
    }
  }

  public ngOnDestroy(): void {
    if (this.triggerSubscription) {
      this.triggerSubscription.unsubscribe();
    }
  }

  public onClick(): void {
    if (this.rtcAnalyticsTrigger()) return;

    this.track();
  }

  public track(): void {
    const rtcAnalyticsTrack = this.rtcAnalyticsTrack();
    if (!rtcAnalyticsTrack) return;

    this.analytics.track(rtcAnalyticsTrack, this.rtcAnalyticsTrackData());
  }
}
